import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 获取文件集合
 * @param {Object} data
 * @returns
 */
export function getFileList (data) {
  return request.post('/ooh-invest/electricAttachFile/getFileList', qs.stringify(data))
}
